import { IndexTable, Text } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { getProducts } from '../../../services/productService';

const DeliveryAddStockTable = ({ product, delivery, onAddQty }) => {
  const [delivered, setDelivered] = useState(initialDelivered(product));
  const [stockAtDeposit, setStockAtDeposit] = useState(
    product.variants.map((v) => ({
      barcode: v.barcode,
      qty: 0,
    })),
  );

  useEffect(() => {
    getProducts({ s: product.family }).then((r) =>
      setStockAtDeposit(
        stockAtDeposit.map((s) => ({
          ...s,
          qty:
            r.data.data[0].stock
              .filter((s) => s.deposit.id === delivery.deposit.id)
              .find((fs) => fs.barcode === s.barcode).qty ?? 0,
        })),
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, delivery]);

  useEffect(() => {
    const qtys = generateStock(product, ({ qty, barcode }) => ({ qty, barcode }))
      .map(({ qty, barcode }) => ({
        barcode,
        qty: (delivered.find((d) => d.barcode === barcode)?.qty ?? 0) - qty,
      }))
      .filter(({ qty }) => qty !== 0);

    onAddQty(qtys);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, delivered]);

  const headings = [{ title: '' }, ...product.variants.map((v) => ({ title: v.title })), { title: 'TOTAL' }] || [];

  return (
    <>
      <IndexTable headings={headings} itemCount={4} selectable={false} lastColumnSticky={true}>
        <QtyExpectedStockRow product={product} />
        <QtyInputStockRow product={product} delivered={delivered} setDelivered={setDelivered} />
        <QtyPendingStockRow product={product} delivered={delivered} />
        <DepositStockRow stockAtDeposit={stockAtDeposit} delivery={delivery} delivered={delivered} />
      </IndexTable>
    </>
  );
};

//Components
const DepositStockRow = ({ stockAtDeposit, delivery, delivered }) => (
  <IndexTable.Row subdued selected={false}>
    <IndexTable.Cell>
      <Text alignment="start" variant="headingXs" fontWeight="bold">
        {delivery.deposit.name}
      </Text>
    </IndexTable.Cell>
    {stockAtDeposit.map((s, i) => (
      <IndexTable.Cell key={i}>
        <Text alignment="center" variant="headingXs" fontWeight="regular">
          {s.qty}{' '}
          {delivered.find((d) => d.barcode === s.barcode).qty
            ? ' -> ' + (s.qty + delivered.find((d) => d.barcode === s.barcode).qty)
            : ''}
        </Text>
      </IndexTable.Cell>
    ))}
    <IndexTable.Cell>
      <Text alignment="center" variant="headingXs" fontWeight="bold">
        {stockAtDeposit.reduce((acc, cur) => acc + cur.qty, 0)}{' '}
        {delivered.reduce((acc, cur) => acc + cur.qty, 0)
          ? ' -> ' +
            (stockAtDeposit.reduce((acc, cur) => acc + cur.qty, 0) + delivered.reduce((acc, cur) => acc + cur.qty, 0))
          : ''}
      </Text>
    </IndexTable.Cell>
  </IndexTable.Row>
);

const QtyExpectedStockRow = ({ product }) => (
  <IndexTable.Row subdued selected={false}>
    <IndexTable.Cell>
      <Text alignment="start" variant="headingXs" fontWeight="bold">
        ENVIADO
      </Text>
    </IndexTable.Cell>
    {generateStock(product, ({ qtyExpected }) => qtyExpected).map((s, i) => (
      <IndexTable.Cell key={i}>
        <Text alignment="center" variant="headingXs" fontWeight="regular">
          {s}
        </Text>
      </IndexTable.Cell>
    ))}
    <IndexTable.Cell>
      <Text alignment="center" variant="headingXs" fontWeight="bold">
        {generateStock(product, ({ qtyExpected }) => qtyExpected).reduce((acc, cur) => acc + cur, 0)}
      </Text>
    </IndexTable.Cell>
  </IndexTable.Row>
);

const QtyPendingStockRow = ({ product, delivered }) => (
  <IndexTable.Row subdued selected={false}>
    <IndexTable.Cell>
      <Text alignment="start" variant="headingXs" fontWeight="bold">
        PENDIENTE
      </Text>
    </IndexTable.Cell>
    {generateStock(product, ({ barcode, qtyExpected }) => ({ barcode, qtyExpected })).map((s, i) => (
      <IndexTable.Cell key={i}>
        <Text alignment="center" variant="headingXs" fontWeight="regular">
          {s.qtyExpected -
            (delivered.find((d) => d.barcode === s.barcode) ? delivered.find((d) => d.barcode === s.barcode).qty : 0)}
          {/* {s.qtyExpected} */}
        </Text>
      </IndexTable.Cell>
    ))}
    <IndexTable.Cell>
      <Text alignment="center" variant="headingXs" fontWeight="bold">
        {generateStock(product, ({ qtyExpected }) => qtyExpected).reduce((acc, cur) => acc + cur, 0) -
          delivered.reduce((acc, cur) => acc + cur.qty, 0)}
      </Text>
    </IndexTable.Cell>
  </IndexTable.Row>
);

const QtyInputStockRow = ({ product, delivered, setDelivered }) => (
  <IndexTable.Row subdued selected={false}>
    <IndexTable.Cell>
      <Text alignment="start" variant="headingXs" fontWeight="bold">
        RECIBIDO
      </Text>
    </IndexTable.Cell>

    {product.variants
      .map((v) => delivered.find((d) => d.barcode === v.barcode))
      .map((d, i) => (
        <IndexTable.Cell key={i}>
          <input
            type="number"
            value={d.qty}
            style={{ width: '40px', borderBottom: '1px solid black', textAlign: 'center' }}
            onChange={(e) =>
              setDelivered([
                ...delivered.filter((ps) => ps.barcode !== d.barcode),
                {
                  barcode: d.barcode,
                  qty: e.target.value ? parseInt(e.target.value) : 0,
                },
              ])
            }
          />
        </IndexTable.Cell>
      ))}

    <IndexTable.Cell>
      <Text alignment="center" variant="headingXs" fontWeight="bold">
        {delivered.reduce((acc, cur) => acc + cur.qty, 0)}
      </Text>
    </IndexTable.Cell>
  </IndexTable.Row>
);

//Helpers
const generateStock = (product, mapFn) =>
  product.variants
    .map((v) => {
      const Sqty = product.stock.find((s) => v.barcode === s.barcode);
      return Sqty ? Sqty : { qty: 0, qtyExpected: 0, barcode: v.barcode };
    })
    .map(mapFn);

const initialDelivered = (product) =>
  product.variants.map((v) => {
    const s = product.stock.find((s) => v.barcode === s.barcode);
    return {
      qty: s ? s.qty : 0,
      barcode: v.barcode,
    };
  });

export default DeliveryAddStockTable;
